import React from 'react';
import { ShieldCheck, ExternalLink, LogOut, LayoutDashboard, Users, UserPlus, HandCoins, Megaphone, FileSpreadsheet } from 'lucide-react';

export const ADMIN_SECTIONS = [
  { id: 'overview', label: 'Overview', short: 'Home', icon: LayoutDashboard },
  { id: 'members', label: 'Members', short: 'Members', icon: Users },
  { id: 'applications', label: 'Applications', short: 'Apply', icon: UserPlus },
  { id: 'donations', label: 'Donations', short: 'Donate', icon: HandCoins },
  { id: 'announcements', label: 'Announcements', short: 'Announce', icon: Megaphone },
  { id: 'export', label: 'Export', short: 'Export', icon: FileSpreadsheet },
];

const NavItems = ({ active, onSelect, compact, badges }) => ADMIN_SECTIONS.map(({ id, label, short, icon: Icon }) => (
  <button key={id} type="button" onClick={() => onSelect(id)}
    className={`jbss-adm-nav-item ${active === id ? 'is-active' : ''}`} data-testid={`admin-nav-${id}${compact ? '-mobile' : ''}`}>
    <Icon size={compact ? 20 : 18} />
    <span>{compact ? short : label}</span>
    {badges[id] > 0 && <em className="jbss-adm-nav-badge">{badges[id]}</em>}
  </button>
));

export const AdminShell = ({ active, onSelect, onViewSite, onLogout, badges = {}, children }) => (
  <div className="jbss-adm">
    <header className="jbss-adm-topbar">
      <div className="jbss-adm-brand" data-testid="admin-header-brand">
        <span className="jbss-adm-brand-icon"><ShieldCheck size={18} /></span>
        <span>JBSS <b>Admin</b></span>
      </div>
      <div className="jbss-adm-top-actions">
        <button type="button" className="jbss-adm-top-btn" onClick={onViewSite} data-testid="admin-view-site">
          <ExternalLink size={15} /><span>View site</span>
        </button>
        <button type="button" className="jbss-adm-top-btn" onClick={onLogout} data-testid="admin-logout">
          <LogOut size={15} /><span>Logout</span>
        </button>
      </div>
    </header>
    <aside className="jbss-adm-sidebar" data-testid="admin-desktop-sidebar">
      <p className="jbss-adm-side-label">Manage</p>
      <NavItems active={active} onSelect={onSelect} badges={badges} />
      <div className="jbss-adm-side-foot">Jai Bheem Seva Sangha (R)<br />Reg.No. DRB3/SOR/153/2026-27</div>
    </aside>
    <main className="jbss-adm-main" key={active}>{children}</main>
    <nav className="jbss-adm-bottomnav" data-testid="admin-mobile-bottom-nav">
      <NavItems active={active} onSelect={onSelect} compact badges={badges} />
    </nav>
  </div>
);

export const SectionHeader = ({ title, subtitle, children }) => (
  <div className="jbss-adm-section-head">
    <div>
      <h1 className="jbss-adm-title">{title}</h1>
      {subtitle && <p className="jbss-adm-subtitle">{subtitle}</p>}
    </div>
    {children && <div className="jbss-adm-head-actions">{children}</div>}
  </div>
);
